/**
 * City of Los Angeles Building Code Configuration
 *
 * Local amendments and specifics for City of LA (LADBS jurisdiction)
 * Inherits from California base codes.
 *
 * Reference: https://dbs.lacity.gov/los-angeles-city-code-documents
 */

export const CITY_OF_LA = {
  id: 'city-of-la',
  inherits: 'california',

  // Jurisdiction metadata
  jurisdiction: {
    name: 'City of Los Angeles',
    shortName: 'City of LA',
    department: 'Los Angeles Department of Building and Safety (LADBS)',
    website: 'https://ladbs.org',
    permitPortal: 'https://www.ladbsservices.lacity.org',
    phone: '(213) 482-0000',
  },

  // Code adoption info
  codeAdoption: {
    codeYear: '2022',
    effectiveDate: '2022-12-23',
    localAmendments: 'LAMC Chapter IX',
    localCodeRef: ' as amended by LAMC',
    notes: '2022 California Building Code with 2023 L.A. Amendments',
  },

  // Code compliance section (jurisdiction-specific, replaces generic)
  codeComplianceSection: {
    id: 'code-compliance',
    title: 'CODE COMPLIANCE',
    scope: [], // Always include
    items: [
      {
        text: 'All work shall comply with the following codes as adopted and amended by the City of Los Angeles:',
        subItems: [
          '{codeYear} California Residential Code (CRC)',
          '{codeYear} California Building Code (CBC)',
          '{codeYear} California Electrical Code (CEC)',
          '{codeYear} California Mechanical Code (CMC)',
          '{codeYear} California Plumbing Code (CPC)',
          '{codeYear} California Energy Code (Title 24, Part 6)',
          '{codeYear} California Green Building Standards Code (CALGreen)',
          'Los Angeles Municipal Code (LAMC) Chapter IX',
        ],
      },
      'Contractor shall obtain all required permits from LADBS prior to commencement of work.',
      'Contractor shall schedule and obtain approval of all required inspections.',
      'All work shall be performed by properly licensed contractors in accordance with California Contractors State License Law.',
    ],
  },

  // Sections to override from base (replaces entire section)
  sectionOverrides: {
    // No full overrides needed - base sections work with localCodeRef placeholder
  },

  // Items to append to base sections
  sectionAppends: {
    // Example: add LA-specific item to electrical section
    // 'electrical': [
    //   'Additional LA-specific electrical requirement here.',
    // ],
  },

  // Additional sections unique to this jurisdiction
  additionalSections: [
    // LA has some specific requirements that could be added here
    // For now, the base California sections cover most needs
  ],
};

export default CITY_OF_LA;
